export default "__VITE_ASSET__DzrgTCC3__"